import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBeatportComponent } from './simple-icons-beatport.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBeatportComponent ],
    exports:      [ SimpleIconsBeatportComponent ],
    bootstrap:    []
})
export class SimpleIconsBeatportModule {}
